import { Divider } from 'antd';
import React, { FC } from 'react';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { getTimeDurationFromSeconds } from '../../utils/DataFormatterUtils';

require('./QuotesDetailDetailsPage.less');

const SimpleLineItemsDisplay = ({ quote, lineItemFieldName, currency }) => {
	return nullSafeGetOrElse(lineItemFieldName, quote, []).map((li, idx) => (
		<div
			key={`${lineItemFieldName}-${idx}`}
			className="sectionHeaderWrapper2"
			style={{
				marginBottom: idx === nullSafeGetOrElse(lineItemFieldName, quote, []).length - 1 ? 16 : 8,
			}}
		>
			<span className="lineItemDetailText">{li.description}</span>
			<span className="lineItemDetailText">{currency.format(parseFloat(li.amount))}</span>
		</div>
	));
};

const QuotesDetailDisplay: FC<any> = ({ currency, quote }): React.ReactElement => {
	return (
		<>
			<Divider />
			<div className="sectionHeaderWrapper">
				<span className="sectionHeaderText">Incurred Costs</span>
				<span className="sectionHeaderText2">
					{currency.format(parseFloat(nullSafeGet(`incurredCostTotalBeforeTax`, quote)) || 0)}
				</span>
			</div>
			<SimpleLineItemsDisplay
				quote={quote}
				lineItemFieldName="incurredCostLineItems"
				currency={currency}
			/>
			<Divider />
			<div className="sectionHeaderWrapper" style={{ marginBottom: 8 }}>
				<span className="sectionHeaderText">Labor</span>
				<span className="sectionHeaderText2">{currency.format(quote.laborTotalBeforeTax)}</span>
			</div>
			{nullSafeGetOrElse('laborLineItems', quote, []).map((lli, idx) => (
				<div
					key={`lli-${idx}`}
					className="sectionHeaderWrapper2"
					style={{
						marginBottom:
							idx === nullSafeGetOrElse('laborLineItems', quote, []).length - 1 ? 16 : 8,
					}}
				>
					<span className="lineItemDetailText">
						{lli.numberOfTech} {lli.roleType} * {getTimeDurationFromSeconds(lli.seconds)} @{' '}
						{currency.format(parseFloat(lli.hourlyRate))} / hour
					</span>
					<span className="lineItemDetailText">{currency.format(parseFloat(lli.amount))}</span>
				</div>
			))}
			<Divider />

			<div className="sectionHeaderWrapper" style={{ marginBottom: 8 }}>
				<span className="sectionHeaderText">Materials</span>
				<span className="sectionHeaderText2">{currency.format(quote.materialTotalBeforeTax)}</span>
			</div>
			{nullSafeGetOrElse('materialLineItems', quote, []).map((mli, idx) => (
				<div
					key={`mali-${idx}`}
					className="sectionHeaderWrapper2"
					style={{
						marginBottom:
							idx === nullSafeGetOrElse('laborLineItems', quote, []).length - 1 ? 16 : 8,
					}}
				>
					<span className="lineItemDetailText">
						{mli.quantity} {mli.unitType} of {mli.description}
						{mli.partNumber ? ` (${mli.partNumber})` : null} @{' '}
						{currency.format(parseFloat(mli.unitPrice))} / {mli.unitType}
					</span>
					<span className="lineItemDetailText">{currency.format(parseFloat(mli.amount))}</span>
				</div>
			))}
			<Divider />
			<div className="sectionHeaderWrapper">
				<span className="sectionHeaderText">Travel</span>
				<span className="sectionHeaderText2">
					{currency.format(parseFloat(quote.travelTotalBeforeTax) || 0)}
				</span>
			</div>
			<SimpleLineItemsDisplay
				quote={quote}
				lineItemFieldName="travelLineItems"
				currency={currency}
			/>
			<Divider />
			<div className="sectionHeaderWrapper">
				<span className="sectionHeaderText">Freight</span>
				<span className="sectionHeaderText2">
					{currency.format(parseFloat(quote.freightTotalBeforeTax) || 0)}
				</span>
			</div>
			<SimpleLineItemsDisplay
				quote={quote}
				lineItemFieldName="freightLineItems"
				currency={currency}
			/>
			<Divider />
			<div className="sectionHeaderWrapper">
				<span className="sectionHeaderText">Miscellaneous</span>
				<span className="sectionHeaderText2">
					{currency.format(parseFloat(nullSafeGet(`miscTotalBeforeTax`, quote)) || 0)}
				</span>
			</div>
			{nullSafeGetOrElse('miscLineItems', quote, []).map((mli, idx) => (
				<div
					key={`mili-${idx}`}
					className="sectionHeaderWrapper2"
					style={{
						marginBottom: idx === nullSafeGetOrElse('miscLineItems', quote, []).length - 1 ? 16 : 8,
					}}
				>
					<span className="lineItemDetailText">{mli.description}</span>
					<span className="lineItemDetailText">{currency.format(parseFloat(mli.amount))}</span>
				</div>
			))}
			<Divider />
			<div className="sectionHeaderWrapper">
				<span className="sectionHeaderText">Total Before Tax</span>
				<span className="sectionHeaderText2">{currency.format(quote.totalBeforeTax)}</span>
			</div>
			<Divider />
			<div className="sectionHeaderWrapper">
				<span className="sectionHeaderText">Tax</span>
				<span className="sectionHeaderText2">{currency.format(quote.tax)}</span>
			</div>
			<Divider />
			<div className="sectionHeaderWrapper">
				<span className="sectionHeaderText" style={{ fontWeight: 600 }}>
					Total After Tax
				</span>
				<span className="sectionHeaderText2" style={{ fontWeight: 600 }}>
					{currency.format(quote.totalAfterTax)}
				</span>
			</div>
		</>
	);
};

export default QuotesDetailDisplay;
